import { gql } from 'apollo-angular';

export const UPDATE_ACTION_READ_STATUS = gql`
  mutation updateSurveyActionStatus($actionId: Int!) {
    updateSurveyActionStatus(actionId: $actionId) {
      data {
        statusMessage
        isSuccess
      }
      isSuccess
      message
      errorCode
    }
  }
`;
